<template>
    <div  class="height" style="background-image: url('/alumBg.jpg')">
        <div class="uk-padding-large" style="background-color: rgba(0, 0, 0, 0.4)">
            <div class="uk-container" style="height: 500px">
                <div class="uk-child-width-1-2@m" uk-grid>
                    <div class=" uk-light">
                        <h2 style="font-weight: bolder">40, 000 + Alumni Strong</h2>
                        <p style="font-size: large; font-weight: bold; color: #c0c0c0;">
                            NCU offers a wide range of alumni associations and chapters, receptions and outings,
                            giving societies, and opportunities to mentor or volunteer, you can always find a way to
                            connect and give back to the Northern Caribbean University family.
                        </p>
                    </div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "alumNumbers"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h2{
            font-size: 1.1em !important;
        }

        p,li{
            font-size: 0.8em !important;
        }
        .height{
            max-height: 250px;
        }

    }
</style>
